import { render } from "./ShoppingCartItemsComponent.vue?vue&type=template&id=607a541e&scoped=true"
import script from "./ShoppingCartItemsComponent.vue?vue&type=script&lang=js"
export * from "./ShoppingCartItemsComponent.vue?vue&type=script&lang=js"

import "./ShoppingCartItemsComponent.vue?vue&type=style&index=0&id=607a541e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607a541e"]])

export default __exports__